import axios from "@/plugins/axios.js";
import store from "@/store";
// state
export const state = {
  details: null,
  intent_id: null,
  client_secret: null,
};

// mutations
export const mutations = {
  SET_LOAD: (state, data) => {
    state.details = data;
  },
  DELETE_DETAILS: (state) => {
    state.details = null;
  },
  SET_INTENT_ID: (state, data) => {
    state.intent_id = data;
  },
  SET_CLIENT_SECRET: (state, data) => {
    state.client_secret = data;
  },
};

// actions
export const actions = {
  async setLoad({ commit }) {
    const { data } = await axios.get(
      "/app/v2/shopping/orderCart/" + store.getters.guestSessionId,
      {
        params: {
          use_credits: store.getters.useCredit ? 1 : 0,
          offer_code: store.getters.offer?.code ?? null,
          delivery_price: store.getters.deliveryPrice,
          service_id:
            store.getters.deliveryMethod === "delivery-service" ? 1 : 2,
        },
      }
    );
    commit("SET_LOAD", data.data);
    commit("SET_INTENT_ID", null);
    commit("SET_CLIENT_SECRET", null);
  },
  async setLoadTableOrder({ commit }) {
    const { data } = await axios.get(
      "/app/v2/shopping/tableCart/" + store.getters.guestSessionId
    );
    commit("SET_LOAD", data.data);
    commit("SET_INTENT_ID", null);
    commit("SET_CLIENT_SECRET", null);
  },
  deleteDetails({ commit }) {
    commit("DELETE_DETAILS");
  },
  setIntentId({ commit }, payload) {
    commit("SET_INTENT_ID", payload);
  },
  setClientSecret({ commit }, payload) {
    commit("SET_CLIENT_SECRET", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
